import axios from 'axios';

let configuredAxios = axios;
configuredAxios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default configuredAxios;
